<!-- Start Forgot Password Area -->
<div class="forgot-password-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="forgot-password-content">
                <div class="row m-0">
                    <div class="col-lg-5 p-0">
                        <div class="image">
                            <i class="bx bx-mail-send image-resend"></i>
                        </div>
                    </div>

                    <div class="col-lg-7 p-0">
                        <div class="forgot-password-form">
                            <h2>Re-enviar correo de confirmación</h2>
                            <p class="mb-0">Por favor, ingresa tu correo para re-enviar la confirmación</p>

                            <form [formGroup]="formResend" (ngSubmit)="submitResend()">
                                <div class="form-group">
                                    <input type="email" formControlName="email"
                                    (focus)="response=''" class="form-control" name="email" placeholder="Correo">
                                    <span class="label-title"><i class='bx bx-envelope'></i></span>
                                </div>
                                <div class="alert alert-info alert-custom" role="alert"
                                    [class.shake-horizontal]="formResend.get('email').hasError('pattern')"
                                    *ngIf="formResend.get('email').hasError('pattern') && (formResend.get('email').dirty || formResend.get('email').touched)">
                                    <span>
                                        <i class="bx bx-help-circle"></i>El email debe ser de la siguiente forma
                                        <b>usuario@serviciodecorreo.com</b>
                                    </span>
                                </div>
                                <div class="alert alert-{{typeResponse}}" role="alert"
                                    [class.shake-horizontal]="response!=''" *ngIf="response!=''">
                                    <span>
                                        <i *ngIf="typeResponse=='info'" class="bx bxs-check-circle"></i>
                                        <i *ngIf="typeResponse=='danger'" class="bx bx-error"></i>
                                        {{response}}
                                    </span>
                                </div>
                                <button type="submit" [disabled]="!formResend.valid" class="forgot-password-btn btn">
                                    <div *ngIf="wait" class="spinner-border" role="status">
                                    </div> <span *ngIf="!wait">Re-enviar Correo</span>
                                </button>
                            </form>
                            <p class="mb-0"><a routerLink="/authentication/login">Cancelar<i width="1em"
                                        data-feather='corner-up-left'></i></a></p>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Forgot Password Area -->